/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import axios from "axios";
import { Language } from "../../common/components/BreadCrumbsLanguageTab";

const languageSupport = async () => {
  const response = await axios.get("/cart/languages");
  const languages: readonly Language[] = JSON.parse(response.data);
  return languages.map((item) => item.languageIso);
};

const getLanguageObj = (id: string, languageId: string, country: string) => {
  return {
    id: id,
    obj: {
      languageId: languageId,
      country: country,
    },
  };
};

//Don't change 0th index of languageSupportData (i.e.. languageSupportData[0]). new lang need to add at end of array.
const languageSupportData = [
  getLanguageObj("en", "en", "US"),
  getLanguageObj("ja", "ja", "JP"),
  getLanguageObj("it", "it", "IT"),
  getLanguageObj("de", "de", "DE"),
  getLanguageObj("es", "es", "ES"),
  getLanguageObj("fr", "fr", "FR"),
  getLanguageObj("ko", "ko", "KR"),
  getLanguageObj("zh-cn", "zh", "CN"),
  getLanguageObj("zh-sg", "zh", "SG"),
  getLanguageObj("zh-hk", "zh", "HK"),
  getLanguageObj("zh-tw", "zh", "TW"),
];

export { languageSupport, languageSupportData };
